import React, { useState, useEffect } from "react";
import styles from "../styles/Workflows.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDown } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import WorkflowCard from "../components/WorkflowCard";
import "../App.css";
import { getWorkflowsSearch } from "../api/api";

const WorkflowsPage = () => {
  const defaultSort = "Most Downloads";

  const [totalPages, setTotalPages] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get("p")) || 1;
  const initialSort = searchParams.get("sort") || defaultSort;
  const initialSearch = searchParams.get("search") || "";

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [sortOption, setSortOption] = useState(initialSort);
  const [search, setSearch] = useState(initialSearch);

  const [workflows, setWorkflows] = useState([]);
  const [totalWorkflows, setTotalWorkflows] = useState(0);

  useEffect(() => {
    const fetchWorkflowsSearch = async () => {
      let sort = "downloads";
      switch (sortOption) {
        case "Most Likes":
          sort = "likes";
          break;
        case "Most Downloads":
          sort = "downloads";
          break;
        case "Recently Uploaded":
          sort = "date";
          break;
        default:
          sort = "downloads";
          break;
      }
      try {
        const data = await getWorkflowsSearch(search, currentPage, sort);
        const pages = data.pages;
        const workflowz = data.files;
        setTotalWorkflows(data.total);
        setWorkflows(workflowz);
        setTotalPages(pages);
      } catch (error) {
        console.error("Error fetching workflows:", error);
      }
    };

    fetchWorkflowsSearch();
  }, [currentPage, search, sortOption]);

  // Update URL when the current page changes
  useEffect(() => {
    const params = {};
    if (currentPage !== 1) params.p = currentPage;
    if (sortOption !== defaultSort) params.sort = sortOption.toLowerCase();
    if (search) params.search = search;
    setSearchParams(params);
  }, [currentPage, sortOption, search, setSearchParams]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSortChange = (option) => {
    setSortOption(option);
    setCurrentPage(1); // Reset to the first page when sort changes
  };

  return (
    <div className="container mt-4">
      {/* Top Row */}
      <div className={styles.topRow}>
        <div className={styles.topRowLeft}>
          <div className={styles.headingRow}>
            <h3>Workflows</h3>
            <p>{totalWorkflows}</p>
          </div>
          <input
            type="text"
            className={styles.filterField}
            placeholder="Filter workflows..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className={styles.topRowRight}>
          <div className={styles.dropdown}>
            <button className={styles.sortBtn}>
              <FontAwesomeIcon
                icon={faArrowsUpDown}
                className={styles.arrowIcon}
              />{" "}
              Sort by: {sortOption}
              <div className={styles.dropdownContent}>
                <p onClick={() => handleSortChange("Most Likes")}>Most Likes</p>
                <p onClick={() => handleSortChange("Most Downloads")}>
                  Most Downloads
                </p>
                <p onClick={() => handleSortChange("Recently Uploaded")}>
                  Recently Uploaded
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Below the Row - Two Columns with Cards */}
      <div className={styles.columns}>
        {workflows.map((workflow) => (
          <WorkflowCard key={workflow.id} workflow={workflow} />
        ))}
      </div>

      {/* Pagination Controls */}
      <div className={styles.pagination}>
        <button
          className={styles.pageBtn}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={`${styles.pageBtn} ${
              currentPage === index + 1 ? styles.active : ""
            }`}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button
          className={styles.pageBtn}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default WorkflowsPage;
